/**
 * Travel runtime tuning (plan R17): `src/travel/runtime/runtime.json`, Zod-validated here. It holds only what the
 * runtime adds to R6's `reach-travel.json`: which ships count as large for the mass-lock, how many are checked per
 * tick, the lane-ring entry check range and where a failed interdiction's attackers appear. Starting values.
 */
import { z } from 'zod'
import runtimeJson from './runtime.json'

const positive = z.number().positive()

export const travelRuntimeConfigSchema = z
  .object({
    comment: z.string().optional(),
    /** Ships at or above this mass (kg) mass-lock the drive within `massLock.shipM`. */
    largeShipMassKg: positive,
    /** Large ships checked for the mass-lock per tick (the rest are ignored). */
    massLockShipSlots: z.number().int().min(0).max(1024),
    /** Lane rings nearer than this (m) are tested for an entry crossing. */
    laneCheckRangeM: positive,
    /** A failed interdiction's group centre sits this far (m) ahead of the nose. */
    interdictorAheadM: positive,
  })
  .strict()

export type TravelRuntimeConfig = z.infer<typeof travelRuntimeConfigSchema>

/** Parses and validates runtime.json (throws a ZodError naming the bad field). */
export function loadTravelRuntimeConfig(raw: unknown = runtimeJson): TravelRuntimeConfig {
  return travelRuntimeConfigSchema.parse(raw)
}
